export type Upload3dEffect =
    | { type: 'attach'; payload: { file_3d: number; name: string } }
    | { type: 'detach' }
    | { type: 'error'; message: string }
    | null;

interface UploadInfo {
    file: { status?: string; name?: string; response?: { id?: number } };
}

/** What a change event of the 3D upload means for the part: attach, detach, tell the user, or nothing. */
export const getUpload3dEffect = (info: UploadInfo): Upload3dEffect => {
    const { status, name = 'the file', response } = info.file;

    if (status === 'done' && response?.id != null) {
        return { type: 'attach', payload: { file_3d: response.id, name } };
    }
    if (status === 'removed') {
        return { type: 'detach' };
    }
    if (status === 'error' || status === 'done') {
        return { type: 'error', message: `We couldn't upload "${name}". Please try again.` };
    }
    return null;
};
